import { Component, defineComponent } from 'vue';

import Faq from './Faq.class';
import FaqItem from './FaqItem.vue';

export default defineComponent({
	components: {
		FaqItem: FaqItem as Component,
	},
	setup: () => {
		const component = new Faq();

		return {
			faqs: component.faqs,
			isFaqsEmpty: component.isFaqsEmpty,
			isPortalTypeMasters: component.isPortalTypeMasters,
			isOpened: component.isOpened.bind(component),
			handleToggle: component.handleToggle.bind(component),
		};
	},
});
